/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AnimalDateType } from '../models/animal-date-type';
import { findAll17 } from '../fn/animal-date-type/find-all-17';
import { FindAll17$Params } from '../fn/animal-date-type/find-all-17';

@Injectable({ providedIn: 'root' })
export class AnimalDateTypeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findAll17()` */
  static readonly FindAll17Path = '/api/values/animal-date-type';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAll17()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll17$Response(params?: FindAll17$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AnimalDateType>>> {
    return findAll17(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findAll17$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll17(params?: FindAll17$Params, context?: HttpContext): Observable<Array<AnimalDateType>> {
    return this.findAll17$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AnimalDateType>>): Array<AnimalDateType> => r.body)
    );
  }

}
